var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 28,
    viewBox: "0 0 8 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H3C3 1 7 1.1 7 5C7 7.9 4.6 6.8 4 9.6C3.4 12.2 5 12.7 4.3 15.4C3.6 18.1 2 16.9 1.3 19.5C0.7 21.7 1.9 22.8 1.7 24.7C1.5 26.5 0.7 27 0.7 27H0",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightC);
export default __webpack_public_path__ + "static/media/right_c.66d7fd56ea69bf1a13cf463d48f68397.svg";
export { ForwardRef as ReactComponent };